"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Modal } from "@/components/ui/modals/Modal";
import { Surface } from "@/components/ui/Surface";
import { GamificationWrapper } from "@/features/gamification/GamificationWrapper";
import type { ChallengeZoneGame } from "./types";
interface ChallengeZoneModalProps {
  game: ChallengeZoneGame | null;
  onClose: () => void;
}

/**
 * Modal that wraps GamificationWrapper to play a game inline on the article page.
 */
export function ChallengeZoneModal(t0) {
  const $ = _c(7);
  const {
    game,
    onClose
  } = t0;
  if (!game) {
    return null;
  }
  const gamificationType = game.type as "classic-quiz" | "personality-quiz" | "poll";
  const t1 = !!game;
  let t2;
  if ($[0] !== game.id || $[1] !== gamificationType) {
    t2 = <Surface slot="modal" className="max-w-2xl w-[90vw] max-h-[85vh] overflow-y-auto"><GamificationWrapper type={gamificationType} id={game.id} /></Surface>;
    $[0] = game.id;
    $[1] = gamificationType;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClose || $[4] !== t1 || $[5] !== t2) {
    t3 = <Modal isOpen={t1} onClose={onClose}>{t2}</Modal>;
    $[3] = onClose;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}